export const date_string = (date) => {
	return new Date(date).toString().substring(4,15)
}